import { themeColor } from "../theme-helper";

export const icons = {
  sizes: {
    tiny: {
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      color: "primary",
      fontSize: "1rem",
      width: "2rem",
      height: "2rem",
    },
    small: {
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      color: "primary",
      fontSize: "1.5rem",
    },
    medium: {
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      color: "primary",
      fontSize: "2rem",
    },
  },
  rating: {
    color: themeColor("variables._mainCTA"),
    fontSize: "2rem",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  tertiary: {
    color: "primary",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    fontSize: "1.5rem",
    width: "2rem",
    height: "3rem",
  },
};
